// @flow

// eslint-disable-next-line complexity
export const stripQuery = (url: ?string): string => {
  if (!url || typeof url !== 'string') {
    return ''
  }

  try {
    const parsed = new URL(url)

    parsed.search = ''

    return parsed.toString()
  } catch (err) {
    return url.split('?')[0]
  }
}
